// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
	margin-bottom: 15px;
	font-family: MuseoSans-500;
	font-size: 18px;
	color: #404141;
}

.disableDiv, .form-control[readonly]{
  pointer-events:none;
}

.back {
  background-color: #e9ecef;
}

button.pre-req {
	text-decoration: none;
}
button.pre-req:hover {
	text-decoration: underline;
}

.btn-link {
	text-align: center;
 	width: auto;
 	padding-left: 0px;
 	padding-right: 0px;
 	font-family: MuseoSans-300;
 	font-size: 12px;
	color: #00A1E0;
}

span.info > img {
	margin-top: 4px;
}

label {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
}

input#address-line1 {
	margin-bottom: 10px;
}

.form-group.zip-code {
	margin-bottom: 2px;
}

.site-zip-code {
	text-transform: uppercase;
	margin-bottom: 2px;
}

.title-vcc {
	margin-bottom: 8px;
	font-family: MuseoSans-500;
	font-size: 18px;
	color: #404141;
}

.form-group.vcc-did-number {
	margin-bottom: 0px;
}

.form-group.vcc-did-number span {
	margin-right: 13px;
	cursor: pointer;
}

.form-group.vcc-did-number label {
	margin-bottom: 0px;
}

.form-group.vcc-did-number input {
	display: inline-block;
	width: 80%;
	margin-bottom: 0px;
}

hr {
	margin-left: -18px;
	margin-right: -18px;
}

.actions {
	position: relative;
	bottom: 20px;
	right: 10px;
	margin-top: 36px;
	margin-right: -10px;
}

input.ng-invalid.ng-touched {
	border: 1px solid red;
}

select.ng-invalid.ng-touched {
	border: 1px solid red;
}

label.btn-secondary {
	background-color: #F5F5F6;
	font-family: MuseoSans-300;
	font-size: 12px;
	margin-bottom: 0px;
	height: 30px;
	width: 96px;
	text-align: center;
	line-height: 1;
	border: none;
	border-radius: 0px;
}

label.btn-secondary.active, label.btn-secondary:active {
	border: 1px solid #00A1E0;
	background-color: transparent;
	color: #00A1E0;
}

label.protocol {
	background-color: #F5F5F6;
	font-family: MuseoSans-300;
	font-size: 12px;
	margin-top: 18px;
	margin-bottom: 2px;
	height: 30px;
	width: 152px;
	text-align: center;
	line-height: 1;
	border: none;
	border-radius: 0px;
}

label.protocol.active, label.protocol:active {
	border: 1px solid #00A1E0;
	background-color: transparent;
	color: #00A1E0;
}

label.currentIP {
	font-family: MuseoSans-300;
	font-size: 12px;
}

label.currentIPAddr {
	font-family: MuseoSans-500;
	font-size: 12px;
	font-weight: 500;
}

select {
	height: 30px !important;
	padding-top: 6px;
	padding-bottom: 6px;
	padding-right: 28px;
  -o-appearance: none;
  appearance: none;
  border-radius: 0px;
  -moz-border-radius: 0px;
  -webkit-border-radius: 0px;
  border: 1px solid #BFBFC0;
  font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
}

select::-ms-expand {
  display: none;
}

select + span {
  float: right;
  margin-top: -27px;
  margin-right: 5px;
  pointer-events: none;
  background-color: #fff;
  padding-right: 5px;
  height: 14px;
}

select + span img {
	width: 14px;
	height: 14px;
	vertical-align: -3px;
}

.title-lan {
	margin-bottom: 13px;
	font-family: MuseoSans-500;
	font-size: 18px;
	color: #404141;
}

.note {
	font-family: MuseoSans-500;
	font-size: 11px;
	color: #ED1C24;
}

.warn {
	vertical-align: top;
	height: 16px !important;
	margin-right: 5px;
}

.thin {
	margin-top: 0px;
	margin-bottom: 5px;
}

.port {
	font-family: MuseoSans-500;
	font-size: 15px;
	color: #404141;
	letter-spacing: 0.02px;
	margin-bottom: 0px;
}

label.dns-servers {
	margin-top: 18px;
}

.required-text {
	margin: 16px 0;
	font-family: MuseoSans-700;
	font-size: 13px;
	color: #ED1C24;
}

.actions {
	position: relative;
	bottom: 20px;
	right: 10px;
	margin-top: 36px;
}

button {
	width: 100px;
}

.btn-primary {
	margin-left: 10px;
}

.required-field::after {
  content: "*";
  color: #ED1C24;
  font-size: 1rem !important;
}

.text-danger {
	font-family: MuseoSans-500;
	font-size: 11px;
	color: #ED1C24;
	width: 400px;
}

.text-danger:first-of-type {
	margin-top: -14px;
}

.text-danger:last-of-type {
	margin-top: 14px;
}
.description {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #ED1C24;
	letter-spacing: 0.01px;
	margin-top: 9px;
	margin-bottom: 0px;
}

#zipCode {
  padding-left: 0;
  margin-right: 0;
  padding-right: 11px;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/site/site.component.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;CAC1B,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;EAGlB,mBAAmB;EAEnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;CAC3B,eAAe;CACf,cAAc;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;AAC5B;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,eAAe;CACf,kBAAkB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".title {\n\tmargin-bottom: 15px;\n\tfont-family: MuseoSans-500;\n\tfont-size: 18px;\n\tcolor: #404141;\n}\n\n.disableDiv, .form-control[readonly]{\n  pointer-events:none;\n}\n\n.back {\n  background-color: #e9ecef;\n}\n\nbutton.pre-req {\n\ttext-decoration: none;\n}\nbutton.pre-req:hover {\n\ttext-decoration: underline;\n}\n\n.btn-link {\n\ttext-align: center;\n \twidth: auto;\n \tpadding-left: 0px;\n \tpadding-right: 0px;\n \tfont-family: MuseoSans-300;\n \tfont-size: 12px;\n\tcolor: #00A1E0;\n}\n\nspan.info > img {\n\tmargin-top: 4px;\n}\n\nlabel {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n}\n\ninput#address-line1 {\n\tmargin-bottom: 10px;\n}\n\n.form-group.zip-code {\n\tmargin-bottom: 2px;\n}\n\n.site-zip-code {\n\ttext-transform: uppercase;\n\tmargin-bottom: 2px;\n}\n\n.title-vcc {\n\tmargin-bottom: 8px;\n\tfont-family: MuseoSans-500;\n\tfont-size: 18px;\n\tcolor: #404141;\n}\n\n.form-group.vcc-did-number {\n\tmargin-bottom: 0px;\n}\n\n.form-group.vcc-did-number span {\n\tmargin-right: 13px;\n\tcursor: pointer;\n}\n\n.form-group.vcc-did-number label {\n\tmargin-bottom: 0px;\n}\n\n.form-group.vcc-did-number input {\n\tdisplay: inline-block;\n\twidth: 80%;\n\tmargin-bottom: 0px;\n}\n\nhr {\n\tmargin-left: -18px;\n\tmargin-right: -18px;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tright: 10px;\n\tmargin-top: 36px;\n\tmargin-right: -10px;\n}\n\ninput.ng-invalid.ng-touched {\n\tborder: 1px solid red;\n}\n\nselect.ng-invalid.ng-touched {\n\tborder: 1px solid red;\n}\n\nlabel.btn-secondary {\n\tbackground-color: #F5F5F6;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tmargin-bottom: 0px;\n\theight: 30px;\n\twidth: 96px;\n\ttext-align: center;\n\tline-height: 1;\n\tborder: none;\n\tborder-radius: 0px;\n}\n\nlabel.btn-secondary.active, label.btn-secondary:active {\n\tborder: 1px solid #00A1E0;\n\tbackground-color: transparent;\n\tcolor: #00A1E0;\n}\n\nlabel.protocol {\n\tbackground-color: #F5F5F6;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tmargin-top: 18px;\n\tmargin-bottom: 2px;\n\theight: 30px;\n\twidth: 152px;\n\ttext-align: center;\n\tline-height: 1;\n\tborder: none;\n\tborder-radius: 0px;\n}\n\nlabel.protocol.active, label.protocol:active {\n\tborder: 1px solid #00A1E0;\n\tbackground-color: transparent;\n\tcolor: #00A1E0;\n}\n\nlabel.currentIP {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n}\n\nlabel.currentIPAddr {\n\tfont-family: MuseoSans-500;\n\tfont-size: 12px;\n\tfont-weight: 500;\n}\n\nselect {\n\theight: 30px !important;\n\tpadding-top: 6px;\n\tpadding-bottom: 6px;\n\tpadding-right: 28px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  border-radius: 0px;\n  -moz-border-radius: 0px;\n  -webkit-border-radius: 0px;\n  border: 1px solid #BFBFC0;\n  font-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n}\n\nselect::-ms-expand {\n  display: none;\n}\n\nselect + span {\n  float: right;\n  margin-top: -27px;\n  margin-right: 5px;\n  pointer-events: none;\n  background-color: #fff;\n  padding-right: 5px;\n  height: 14px;\n}\n\nselect + span img {\n\twidth: 14px;\n\theight: 14px;\n\tvertical-align: -3px;\n}\n\n.title-lan {\n\tmargin-bottom: 13px;\n\tfont-family: MuseoSans-500;\n\tfont-size: 18px;\n\tcolor: #404141;\n}\n\n.note {\n\tfont-family: MuseoSans-500;\n\tfont-size: 11px;\n\tcolor: #ED1C24;\n}\n\n.warn {\n\tvertical-align: top;\n\theight: 16px !important;\n\tmargin-right: 5px;\n}\n\n.thin {\n\tmargin-top: 0px;\n\tmargin-bottom: 5px;\n}\n\n.port {\n\tfont-family: MuseoSans-500;\n\tfont-size: 15px;\n\tcolor: #404141;\n\tletter-spacing: 0.02px;\n\tmargin-bottom: 0px;\n}\n\nlabel.dns-servers {\n\tmargin-top: 18px;\n}\n\n.required-text {\n\tmargin: 16px 0;\n\tfont-family: MuseoSans-700;\n\tfont-size: 13px;\n\tcolor: #ED1C24;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tright: 10px;\n\tmargin-top: 36px;\n}\n\nbutton {\n\twidth: 100px;\n}\n\n.btn-primary {\n\tmargin-left: 10px;\n}\n\n.required-field::after {\n  content: \"*\";\n  color: #ED1C24;\n  font-size: 1rem !important;\n}\n\n.text-danger {\n\tfont-family: MuseoSans-500;\n\tfont-size: 11px;\n\tcolor: #ED1C24;\n\twidth: 400px;\n}\n\n.text-danger:first-of-type {\n\tmargin-top: -14px;\n}\n\n.text-danger:last-of-type {\n\tmargin-top: 14px;\n}\n.description {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #ED1C24;\n\tletter-spacing: 0.01px;\n\tmargin-top: 9px;\n\tmargin-bottom: 0px;\n}\n\n#zipCode {\n  padding-left: 0;\n  margin-right: 0;\n  padding-right: 11px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
